window.TravelExpedia = (function ($, util, components) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        elements: {
            buttons: {
                noVoucherCloseModalButton: '#expedia-no-voucher-modal .vds-modal__close',
                noVoucherCancelButton: '#expedia-no-voucher-modal-cancel',
                noVoucherContinueButton: '#expedia-no-voucher-modal-continue',
                refreshButton: '#expedia-refresh-button',
                refreshModalCloseModalButton: '#expedia-refresh-modal .vds-modal__close',
                pleaseWaitButton: '#expedia-pleasewait-button',
                guardedButtons: '.guarded-button',
                expediaBookButton: '#expedia-book-button'
            },
            checkboxes: {
                guards: '.checkbox-guard'
            },
            ids: {
                noVoucherModal: 'expedia-no-voucher-modal',
                refreshModal: 'expedia-refresh-modal',
                hasVoucherAvailable: '#hasVoucherAvailable'
            }
        },
        func: {
            init: function () {
                self.func.bindings();
            },
            bindings: function () {
                $(self.elements.buttons.expediaBookButton).on('click', self.func.bookNowButtonClick);
                $(self.elements.buttons.noVoucherCloseModalButton).on('click', self.func.closeNoVoucherModal);
                $(self.elements.buttons.noVoucherCancelButton).on('click', self.func.closeNoVoucherModal);
                $(self.elements.buttons.noVoucherContinueButton).on('click', self.func.redirectWithNoVoucher);
                $(self.elements.buttons.refreshButton).on('click', self.func.refreshButtonClick);
            },
            bookNowButtonClick: function (e) {
                if (components.ComplianceInformation.Func.IsSignUpButtonEnabled()) {
                    const hasVoucherAvailable = $(self.elements.ids.hasVoucherAvailable).val();
                    if (hasVoucherAvailable === 'true') {
                        window.dataLayer.push({
                            event: self.gtm.event.ctaClick,
                            clickValue: self.gtm.clickValue.bookNow,
                            bookings: self.gtm.bookings.bookings
                        });

                        self.func.openRefreshModal();

                    } else {
                        e.preventDefault();
                        window.dataLayer.push({
                            event: self.gtm.event.ctaClick,
                            clickValue: self.gtm.clickValue.bookNow,
                            bookings: self.gtm.bookings.noBookings
                        });
                        self.func.openNoVoucherModal();
                    }
                }
            },
            refreshButtonClick: function () {
                $(self.elements.buttons.refreshButton).hide();
                $(self.elements.buttons.refreshModalCloseModalButton).hide();
                $(self.elements.buttons.pleaseWaitButton).show();
                util.func.reloadPage();
            },
            redirectWithNoVoucher: function () {
                if (this.id === self.elements.buttons.noVoucherContinueButton) {
                    window.dataLayer.push({
                        event: self.gtm.event.ctaClick,
                        clickValue: self.gtm.clickValue.continue,
                        bookings: self.gtm.bookings.noBookings
                    });
                }

                self.func.closeNoVoucherModal();
                self.func.disableElements();

                return true;
            },
            openNoVoucherModal: function () {
                util.func.openModal(self.elements.ids.noVoucherModal);
            },
            closeNoVoucherModal: function () {
                util.func.closeModal(self.elements.ids.noVoucherModal);
            },
            openRefreshModal: function () {
                util.func.openModal(self.elements.ids.refreshModal);
            },
            disableElements: function () {
                $(self.elements.checkboxes.guards).prop('checked', false);
                $(self.elements.buttons.expediaBookButton).addClass('vds-button--disabled');
            }
        },
        gtm: {
            event: {
                ctaClick: 'ctaClick'
            },
            clickValue: {
                bookNow: 'book-now',
                cancel: 'cancel',
                continue: 'continue'

            },
            bookings: {
                bookings: 'bookings-available',
                noBookings: 'no-bookings-available'
            }
        }
    };

    return {
        init: self.func.init
    };
})(window.jQuery, window.Utilities, { ComplianceInformation: window.ComplianceInformation });
$('document').ready(function () {
    if ('expedia' === $('#page-data').data('feature')) {
        window.TravelExpedia.init();
    }
    if ($('#expedia-external-redirect-link').length) {
        const destination = $('#expedia-external-redirect-link').attr('href');
        window.location.replace(destination);
}
});
